export const organizationJsonLd = () =>
  JSON.stringify({
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Bancony",
    legalName: "Bancony ehf.",
    url: "https://bancony.com",
    logo: "https://bancony.com/bancony_logo_548.png",
    description:
      "Bancony brings a bank to AI: accounts, payments and services available to AI agents on the open bank2ai standard, plus a customer-ready assistant inside the bank's own app. Live in weeks, compliant, no vendor lock-in.",
    sameAs: [
      "https://bank2ai.com",
      "https://github.com/bank2ai/bank2ai",
    ],
    address: {
      "@type": "PostalAddress",
      addressCountry: "IS",
      addressLocality: "Reykjavík",
    },
    contactPoint: [
      {
        "@type": "ContactPoint",
        contactType: "sales",
        email: "hello@bancony.com",
        areaServed: "Worldwide",
      },
    ],
  });
